import React from 'react'
import { css } from 'emotion'

const RewardsContainerView = ({ RewardsElement }) => (
  <div className={styles.container}>{RewardsElement}</div>
)

const styles = {
  container: css({
    height: '68rem',
    width: '39rem',
  }),
}

export default RewardsContainerView
